import { useEffect, useState, RefObject } from 'react';
import { useIntl } from 'gatsby-plugin-intl';
import { StaticImage } from 'gatsby-plugin-image';

import useKeyValuePairs from '../../hooks/useKeyValuePairs';

import { BackToTopWrapper, ScrollUpButton } from './styles';

interface BackToTopProps {
  scrollFocusElement?: RefObject<HTMLElement>;
  label?: string;
}
const BackToTop = ({ scrollFocusElement, label }: BackToTopProps) => {
  const intl = useIntl();
  const keyValuePairs = useKeyValuePairs(intl.locale);
  const title = label || keyValuePairs.BACK_TO_TOP;
  const [visible, setVisible] = useState(false);
  const [pageHeight, setPageHeight] = useState(1000);

  // Set page depth for when button appears
  useEffect(() => {
    setPageHeight(document.body.scrollHeight * 0.2);
  }, []);

  // Smooth scroll to top of page when button is clicked
  const scrollToTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    // Trigger button to be visible once page depth is reach and hide before
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;

      if (scrolled > pageHeight) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisible);

    return () => window.removeEventListener('scroll', toggleVisible);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BackToTopWrapper>
      <ScrollUpButton
        isVisible={visible}
        onClick={(e) => {
          e.preventDefault();
          scrollToTop();
          // Set short timeout to enable browser to add focus back to the scrollFocusElement
          if (scrollFocusElement?.current) {
            setTimeout(() => {
              scrollFocusElement?.current?.focus();
            }, 300);
          }
        }}
        aria-label={
          intl.locale === 'fr'
            ? 'Retour en haut de page'
            : 'Back to top of page'
        }
      >
        <StaticImage src="../../images/back-to-top.svg" alt="" />
        <span>{title}</span>
      </ScrollUpButton>
    </BackToTopWrapper>
  );
};

export default BackToTop;
